import { ReactComponent as MailIconSVG } from '@/assets/icons/MailIcon.svg';
import { SVGProps } from 'react';

const MailIcon = (props: SVGProps<SVGSVGElement>) => <MailIconSVG {...props} />;

export default MailIcon;
